import Swiper from '../lib/swiper';

class Slider {
	constructor() {
		this.sliderInstance = new Swiper('.lc-slider', {
      autoplay: {
        delay: 5000
      },
			loop: true,
      speed: 500,
			slideClass: 'lc-slider-item',
			slidesPerView: 1,
			spaceBetween: 0,
      navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
			pagination: {
				el: '.swiper-pagination',
        type: 'bullets'
			}
		});
	}
} export default Slider;
